import React, { useCallback } from "react";
import ReactGA from "react-ga4";
import { isDev } from "config/env";
import { SignupChargeDetails } from "features/types";
import { useAppSelector } from "../useAppSelector";
import { useAppDispatch } from "../useAppDispatch";
import { resetBuyFlow } from "features/slices/buyFlowSlice";
import { StripeTokenResponse } from "components/StripePaymentForm/StripePaymentForm";
import conversionFunctions from "./conversionFunctions";

function useSendConversionData() {
  const { tenantSubdomain } = useAppSelector((state) => state.tenant);
  const dispatch = useAppDispatch();

  const sendConversionData = useCallback(function (
    signupCharge: SignupChargeDetails | null,
    totalQuantity: number,
    billingToken?: StripeTokenResponse
  ) {
    if (signupCharge && !isDev && tenantSubdomain) {
      const totalCharge =
        parseFloat(signupCharge.signupCharge) +
        signupCharge.remainingMonths * parseFloat(signupCharge.recurringCharge);

      // send purchase event to FanRally GA4
      // Send a custom event
      ReactGA.event("purchase", {
        value: totalCharge,
        currency: "USD",
        transaction_id: billingToken?.token.id,
        quantity: totalQuantity,
      });

      // send conversion tracking data to tenant as well
      const conversionFunction = conversionFunctions[tenantSubdomain!];
      conversionFunction &&
        conversionFunction(
          totalCharge,
          totalQuantity,
          billingToken?.token.card
        );
      dispatch(resetBuyFlow());
    }
  },
  []);

  return sendConversionData;
}

export default useSendConversionData;
